<template>
    <div>
        <table class="table" v-if="dados.length > 0" :key="toggleKey">
            <thead>
                <th>#</th>
                <th>Imagem</th>
                <th>Nome</th>
                <th>Tamanho</th>
                <th>Ativo</th>
                <th class="right-align">Ações</th>
            </thead>
            <tbody>
                <tr v-for="file in dados">
                    <td>{{ file.id }}</td>
                    <td>
                        <img :src="$url+'/api/adm/produto-imagens/src/'+file.id" width="100" height="100" />
                    </td>
                    <td>{{ file.arquivo.nome }}</td>
                    <td>{{ file.arquivo.size }}</td>
                    <td>
                        <toggle 
                            :id="'imagemAtivoToggle'+file.arquivo.id"
                            :key="toggleKey"
                            :default="file.ativo_site"
                            @tchange="update(file)">
                        </toggle>
                    </td>
                    <td class="right-align">
                        <button 
                            class="btn btn-primary"
                            @click="show(file)">
                            <i class="fas fa-eye"></i>
                        </button>
                        <button 
                            class="btn btn-danger"
                            @click="destroy(file)">
                            <i class="fas fa-trash"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
        <div v-else>
            Nenhuma foto do produto cadastrada
        </div>
    </div>
</template>

<script>
	export default {
        data(){
            return {
                dados: [],
                toggleKey: 1
            }
        },
        created(){
            this.getDados()
        },
		methods: {
            getDados(){
                axios.get(this.$url+'/api/adm/produto-imagens/list/'+this.$route.params.id)
                .then(response => {
                    this.dados = response.data
                })
                .catch(error => {
                    console.log(error)
                });
            },
			show(file){
				this.$emit('show', file);
			},
            update(file){
                var config = {
                    position: 'bottom-right',
                };

                var dados = {
                    'ativo_site': !file.ativo_site
                }

                axios.put(this.$url+'/api/adm/produto-imagens/update/'+file.id, (dados))
                .then(response => {
                    this.$bshMessage.show(response.data.message, response.data.type, config)
                    this.$emit('reload');
                })
                .catch(error => (this.errors = error.response.data.errors));
            },
            destroy(file){
                this.$emit('destroy', file);
            },
		},
        watch: {
            dados(){
                this.toggleKey += 1;
            }
        }
	}
</script>

<style scoped>
    .right-align {
        text-align: right;
    }
</style>